import React, { useState, useEffect } from "react";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import FacebookIcon from "@mui/icons-material/Facebook";
import FacebookBCAccess from "./FacebookBCAccess";

interface FacebookManageProps {}

const ExistingPages: React.FC<FacebookManageProps> = () => {
  const [pagesData, setPagesData] = useState<any[]>([]);
  const [selectedTab] = useState<string>("nav-fb-tab");

  useEffect(() => {
    NetworkManager.sendJsonRequest(
      "broadcastMessageTemplates/getConnectedBroadcastPages",
      "",
      "",
      "GET",
      true,
      onSuccessCall,
      onErrorCall
    );
  }, []);

  const onSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    let connectedFbList = respData.connectedList;
    if (connectedFbList) {
      setPagesData(connectedFbList);
    }
  };
  const onErrorCall = (err: any) => {};

  const fbPages = pagesData.filter(
    (fb: any) => fb["facebook"] && Object.keys(fb)?.length === 1
  );
  const fbPagesCount = fbPages.length;

  return (
    <div className="account-pages container-login100 mt-0.5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 text-center mb-2">
            <img src="../assets/images/Logo.png" alt="" />
          </div>
        </div>
        <div className="row justify-content-center mb-4 manage">
          <div className="col-md-12 col-lg-8 col-xl-6">
            <div className="manage-page">
              <nav>
                <div
                  className="nav nav-tabs justify-content-center"
                  id="nav-tab"
                  role="tablist">
                  <button
                    className={`nav-item nav-link ${
                      selectedTab === "nav-fb-tab" ? "active" : ""
                    }`}
                    id="nav-fb-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    // onClick={ontabChange}
                  >
                    {" "}
                    <FacebookIcon color="primary" />
                    Facebook
                  </button>
                </div>
              </nav>{" "}
              {selectedTab === "nav-fb-tab" ? (
                <div id="nav-fb-tab">
                  <FacebookBCAccess data={fbPages} count={fbPagesCount} />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExistingPages;
